import _regeneratorRuntime from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import { loadAbsorbersPlugin } from "./Plugins/Absorbers";
import { loadEmittersPlugin } from "./Plugins/Emitters";
import { loadExternalTrailInteraction } from "./Interactions/External/Trail";
import { loadPolygonMaskPlugin } from "./Plugins/PolygonMask";
import { loadRollUpdater } from "./Updaters/Roll";
import { loadSlim } from "./slim";
import { loadTiltUpdater } from "./Updaters/Tilt";
import { loadTwinkleUpdater } from "./Updaters/Twinkle";
import { loadWobbleUpdater } from "./Updaters/Wobble";
export function loadFull(engine) {
  return _regeneratorRuntime.async(function loadFull$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _regeneratorRuntime.awrap(loadSlim(engine));

        case 2:
          _context.next = 4;
          return _regeneratorRuntime.awrap(loadRollUpdater(engine));

        case 4:
          _context.next = 6;
          return _regeneratorRuntime.awrap(loadTiltUpdater(engine));

        case 6:
          _context.next = 8;
          return _regeneratorRuntime.awrap(loadTwinkleUpdater(engine));

        case 8:
          _context.next = 10;
          return _regeneratorRuntime.awrap(loadWobbleUpdater(engine));

        case 10:
          _context.next = 12;
          return _regeneratorRuntime.awrap(loadExternalTrailInteraction(engine));

        case 12:
          _context.next = 14;
          return _regeneratorRuntime.awrap(loadAbsorbersPlugin(engine));

        case 14:
          _context.next = 16;
          return _regeneratorRuntime.awrap(loadEmittersPlugin(engine));

        case 16:
          _context.next = 18;
          return _regeneratorRuntime.awrap(loadPolygonMaskPlugin(engine));

        case 18:
        case "end":
          return _context.stop();
      }
    }
  });
}